import { VectorIcon } from 'components/Icons';
import RevxFlexLayout from 'components/RevxFlexLayout';
import './index.less';

interface RevxNoProofTipProps {
  show?: boolean;
  style?: object;
  className?: string;
}

export const RevxNoProofTip = (props: RevxNoProofTipProps) => {
  const { show, style, className } = props;
  return (
    <RevxFlexLayout
      align="center"
      className={`noProof-tip ${className}`}
      style={{
        opacity: show ? 1 : 0,
        ...style,
      }}
    >
      <VectorIcon
        style={{
          fontSize: 17,
        }}
      />
      <span>No PDF proof required</span>
    </RevxFlexLayout>
  );
};
